import { configureStore } from "@reduxjs/toolkit";
import navReducer from "./navReducer";
import adminReducer from "../services/admin/adminReducer";
import organisationReducer from "./organisationReducer";
import licenseReducer from "./licenseReducer";
import { notificationReducer } from "./notificationReducer";
import { adminApi } from "../services/admin/admin.rtk.api";
import { organisationApi } from "../services/organisation/organisation.rtk.api";
import { gymApi } from "../services/gym/gym.rtk.api";
import { staffApi } from "../services/staff/staff.rtk.api";
import { subscriptionLicenseApi } from "../services/subscription/subscriptionLicense.rtk.api";
import { subscriptionPaymentApi } from "../services/subscription/subscriptionPayment.rtk.api";
import { subscriptionBillingApi } from "../services/subscription/subscriptionBilling.rtk.api";
import { fileApi } from "../services/workout/files/file.rtk.api";
import { exerciseApi } from "../services/workout/exercise/exercise.rtk.api";
import { workoutSessionApi } from "../services/workout/session/session.rtk.api";
import { scheduleApi } from "../services/workout/schedule/schedule.rtk.api";
import { formatApi } from "../services/workout/session/format.rtk.api";
import { categoryApi } from "../services/workout/session/category.rtk.api";
import { equipmentApi } from "../services/workout/exercise/equipment.rtk.api";
import { muscleApi } from "../services/workout/exercise/muscle.rtk.api";
import { metricsApi } from "../services/workout/session/metrics.rtk.api";
import { groupApi } from "../services/workout/session/group.rtk.api";
import { deviceApi } from "../services/device/device.rtk.api";

// 1. Import the themeApi
import { themeApi } from "../services/settings/setting.rtk.api"; // <--- ADD THIS

export const store = configureStore({
  reducer: {
    navbar: navReducer,
    admin: adminReducer,
    organisation: organisationReducer,
    license: licenseReducer,
    notification: notificationReducer,
    [adminApi.reducerPath]: adminApi.reducer,
    [organisationApi.reducerPath]: organisationApi.reducer,
    [gymApi.reducerPath]: gymApi.reducer,
    [staffApi.reducerPath]: staffApi.reducer,
    [subscriptionLicenseApi.reducerPath]: subscriptionLicenseApi.reducer,
    [subscriptionPaymentApi.reducerPath]: subscriptionPaymentApi.reducer,
    [subscriptionBillingApi.reducerPath]: subscriptionBillingApi.reducer,
    [fileApi.reducerPath]: fileApi.reducer,
    [exerciseApi.reducerPath]: exerciseApi.reducer,
    [workoutSessionApi.reducerPath]: workoutSessionApi.reducer,
    [scheduleApi.reducerPath]: scheduleApi.reducer,
    [metricsApi.reducerPath]: metricsApi.reducer,
    [formatApi.reducerPath]: formatApi.reducer,
    [categoryApi.reducerPath]: categoryApi.reducer,
    [equipmentApi.reducerPath]: equipmentApi.reducer,
    [muscleApi.reducerPath]: muscleApi.reducer,
    [groupApi.reducerPath]: groupApi.reducer,
    [deviceApi.reducerPath]: deviceApi.reducer,
    
    // 2. Add the themeApi reducer
    [themeApi.reducerPath]: themeApi.reducer, // <--- ADD THIS
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      adminApi.middleware,
      organisationApi.middleware,
      gymApi.middleware,
      staffApi.middleware,
      subscriptionLicenseApi.middleware,
      subscriptionPaymentApi.middleware,
      subscriptionBillingApi.middleware,
      fileApi.middleware,
      exerciseApi.middleware,
      workoutSessionApi.middleware,
      scheduleApi.middleware,
      formatApi.middleware,
      categoryApi.middleware,
      equipmentApi.middleware,
      muscleApi.middleware,
      metricsApi.middleware,
      groupApi.middleware,
      deviceApi.middleware,
      
      // 3. Add the themeApi middleware
      themeApi.middleware // <--- ADD THIS
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;